import { graphql } from "../../../gql/index.ts";

export const FrozenWeekFragment = graphql(`
  fragment FrozenWeek on FrozenWeekDto {
    startOfWeekUtc
    endOfWeekUtc
  }
`);
